import type { RouteObject } from 'react-router';
import { AppShell } from './components/AppShell';
import { BuildPage } from './pages/BuildPage';
import { BuilderPage } from './pages/BuilderPage';
import { DrawPage } from './pages/DrawPage';
import { HomePage } from './pages/HomePage';
import { LibraryPage } from './pages/LibraryPage';
import { LoginPage } from './pages/LoginPage';
import { PuzzleDetailsPage } from './pages/PuzzleDetailsPage';
import { StatsPage } from './pages/StatsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SettingsPage } from './pages/SettingsPage';
import { SolvePage } from './pages/SolvePage';
import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminBatchPage } from './pages/admin/AdminBatchPage';
import { AdminCostsPage } from './pages/admin/AdminCostsPage';
import { AdminGeneratorPage } from './pages/admin/AdminGeneratorPage';
import { AdminImportPage } from './pages/admin/AdminImportPage';
import { AdminNeedsPluginPage } from './pages/admin/AdminNeedsPluginPage';
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage';
import { AdminPoolPage } from './pages/admin/AdminPoolPage';
import { AdminSourcesPage } from './pages/admin/AdminSourcesPage';
import { AdminSolverReportPage } from './pages/admin/AdminSolverReportPage';
import { AdminHealthPage } from './pages/admin/AdminHealthPage';
import { AdminLibraryToolsPage } from './pages/admin/AdminLibraryToolsPage';

export const routes: RouteObject[] = [
  { path: '/login', element: <LoginPage /> },
  // The screenshot tests' drawing page, in development builds only.
  ...(import.meta.env.DEV ? [{ path: '/__draw', element: <DrawPage /> }] : []),
  { path: '/puzzle/:id', element: <SolvePage /> },
  { path: '/build/:id', element: <BuilderPage /> },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminOverviewPage /> },
      { path: 'sources', element: <AdminSourcesPage /> },
      { path: 'import', element: <AdminImportPage /> },
      { path: 'generator', element: <AdminGeneratorPage /> },
      { path: 'pool', element: <AdminPoolPage /> },
      { path: 'costs', element: <AdminCostsPage /> },
      { path: 'batch', element: <AdminBatchPage /> },
      { path: 'needs-plugin', element: <AdminNeedsPluginPage /> },
      { path: 'solver', element: <AdminSolverReportPage /> },
      { path: 'health', element: <AdminHealthPage /> },
      { path: 'library', element: <AdminLibraryToolsPage /> },
    ],
  },
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/library', element: <LibraryPage /> },
      { path: '/library/:id', element: <PuzzleDetailsPage /> },
      { path: '/stats/:who', element: <StatsPage /> },
      { path: '/build', element: <BuildPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
